import React, {memo, useCallback, useMemo, useState} from 'react';
import {ColumnModel, SettingsList} from '../../../../components/Settings/SettingsList';
import {DoorBrandModel} from '../../../../types/door-brand';
import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import {useSelector} from 'react-redux';
import {DEVELOPER_URL} from '../../index';
import {useLocalization} from "../../../../hooks/localization";

const keyExtractor = (item: DoorBrandModel) => item.id;

export const DoorBrandListScreen = memo(function DoorBrandListScreen() {
    const {t} = useLocalization();
    const doorBrandList = useSelector(state => state.control.doorBrandList);

    const [selectedDoorBrand, setSelectedDoorBrand] = useState<DoorBrandModel>(null);

    const buttons = useMemo(() => [
        {
            text: t('edit'),
            url: `/developer/door-brand/edit/${selectedDoorBrand?.id || ''}`,
            className: 'orange',
            hidden: !(selectedDoorBrand),
        },
        {
            text: t('create_door_brand'),
            url: '/developer/door-brand/edit',
            className: 'green',
        },
    ], [t, selectedDoorBrand]);

    const displayNameExtractor = useCallback((item: DoorBrandModel, column: ColumnModel) => {
        return item[column.key] || '-';
    }, []);

    const columns = useMemo<ColumnModel[]>(() => [
        {
            length: 3,
            name: t('door_brand_name'),
            key: 'name',
        },
    ], [t]);

    return (
        <PasswordContainer requiredRole="developer" isFullscreen={true}>
            <SettingsPageContainer buttons={buttons} backUrl={DEVELOPER_URL}>
                <SettingsList
                    columns={columns}
                    items={doorBrandList}
                    listType="doorBrandList"
                    displayNameExtractor={displayNameExtractor}
                    keyExtractor={keyExtractor}
                    selectedItem={selectedDoorBrand}
                    onItemSelected={setSelectedDoorBrand}/>
            </SettingsPageContainer>
        </PasswordContainer>
    );
});
